// extracted by mini-css-extract-plugin
module.exports = {"button-icon":"ProfileTitle_button-icon__sJmyt","edit-profile-dialog":"ProfileTitle_edit-profile-dialog__A16zR"};